(function () {
  'use strict';

  class MtHeroThumbs {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      this.thumbs = Array.from(root.querySelectorAll('[data-hero-thumb]'));
      this.activeIndex = 0;
      this.autoplayTimer = null;
      this.destroyed = false;

      if (!this.slides.length) {
        this.destroyed = true;
        return;
      }

      this.autoplay = root.dataset.autoplay === 'true';
      this.autoplayDelay = parseInt(root.dataset.autoplayDelay, 10) || 6000;

      this.onThumbClick = this.onThumbClick.bind(this);

      this.init();
    }

    init() {
      this.update();
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', this.onThumbClick);
      });

      if (this.autoplay && this.slides.length > 1) {
        this.startAutoplay();
        this.root.addEventListener('mouseenter', () => this.stopAutoplay());
        this.root.addEventListener('mouseleave', () => this.startAutoplay());
        this.root.addEventListener('focusin', () => this.stopAutoplay());
        this.root.addEventListener('focusout', () => this.startAutoplay());
      }
    }

    onThumbClick(event) {
      const thumb = event.currentTarget;
      const index = parseInt(thumb.dataset.heroThumb, 10);
      if (Number.isNaN(index) || index === this.activeIndex) return;
      this.goTo(index);
    }

    goTo(index) {
      if (index < 0 || index >= this.slides.length) return;
      this.activeIndex = index;
      this.update();
      if (this.autoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    update() {
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.activeIndex);
        slide.setAttribute('aria-hidden', i === this.activeIndex ? 'false' : 'true');
      });

      this.thumbs.forEach((thumb, i) => {
        const isActive = i === this.activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplay || this.slides.length < 2) return;

      this.autoplayTimer = window.setInterval(() => {
        const next = (this.activeIndex + 1) % this.slides.length;
        this.goTo(next);
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    destroy() {
      this.stopAutoplay();
      this.thumbs.forEach((thumb) => {
        thumb.removeEventListener('click', this.onThumbClick);
      });
      this.destroyed = true;
    }
  }

  const instances = new Map();

  function initHeroThumbs(scope) {
    if (!scope) scope = document;
    const roots = scope.querySelectorAll('[data-hero-thumbs]');
    roots.forEach((root) => {
      if (instances.has(root)) return;
      const instance = new MtHeroThumbs(root);
      if (!instance.destroyed) {
        instances.set(root, instance);
      }
    });
  }

  function destroyHeroThumbs(scope) {
    if (!scope) scope = document;
    const roots = scope.querySelectorAll('[data-hero-thumbs]');
    roots.forEach((root) => {
      const instance = instances.get(root);
      if (instance) {
        instance.destroy();
        instances.delete(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeroThumbs());
  } else {
    initHeroThumbs();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHeroThumbs(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyHeroThumbs(event.target);
  });
})();
